import http from '@/plugins/axios';

const BASE_URL_PAGE = '/page-templates';
const BASE_URL_PAGE_COUNTRY = '/country-page-templates';

const BASE_URL_EMAIL = '/email-templates';
const BASE_URL_COUNTRY = '/country-email-templates';

export default {
  // GET
  getEmailReviewrequestTemplate: (advanced = true) =>
    http.get(`${BASE_URL_EMAIL}/review_request/load-json?advanced_template=${advanced}`),
  getCountryEmailReviewrequestTemplates: advanced =>
    http.get(`${BASE_URL_COUNTRY}/review_request/load-json?advanced_template=${advanced}`),
  getEmailCouponTemplate: (advanced = true) =>
    http.get(`${BASE_URL_EMAIL}/coupon/load-json?advanced_template=${advanced}`),
  getCountryEmailCouponTemplate: advanced =>
    http.get(`${BASE_URL_COUNTRY}/coupon/load-json?advanced_template=${advanced}`),
  getEmailVerifyEmailTemplate: (advanced = true) =>
    http.get(`${BASE_URL_EMAIL}/verify_email/load-json?advanced_template=${advanced}`),
  getEmailPhotoRequestTemplate: (advanced = true) =>
    http.get(`${BASE_URL_EMAIL}/photo_request/load-json?advanced_template=${advanced}`),
  getCountryEmailPhotoRequestTemplate: advanced =>
    http.get(`${BASE_URL_COUNTRY}/photo_request/load-json?advanced_template=${advanced}`),
  getCountryVerifyEmailRequestTemplate: advanced =>
    http.get(`${BASE_URL_COUNTRY}/verify_email/load-json?advanced_template=${advanced}`),
  getPageTemplate: () => http.get(`${BASE_URL_PAGE}/thank_you_for_review/load-json`),
  getSmsReviewrequestTemplate: () => http.get(`${BASE_URL_EMAIL}/review_request_sms/load-json`),
  getOrderPrinterTemplate: () => http.get(`${BASE_URL_EMAIL}/order_printer/load-json`),
  getSettingsEmailReviewrequest: () => http.get(`${BASE_URL_EMAIL}/review_request/settings`),
  getSettingsEmailReviewrequestCountry: () =>
    http.get(`${BASE_URL_COUNTRY}/review_request/settings`),
  getThxPageCountry: () => http.get(`${BASE_URL_PAGE}/thank_you_for_review/save-country-page`),
  getSettingsCoupon: () => http.get(`${BASE_URL_EMAIL}/coupon/settings`),
  getSettingsCouponCountry: () => http.get(`${BASE_URL_COUNTRY}/coupon/settings`),
  getSettingsSmsCountry: () => http.get(`${BASE_URL_COUNTRY}/review_request_sms/settings`),
  getSettingsEmailPhotoRequest: () => http.get(`${BASE_URL_EMAIL}/photo_request/settings`),
  getSettingsEmailPhotoRequestCountry: () => http.get(`${BASE_URL_COUNTRY}/photo_request/settings`),
  getSettingsVerifyEmailCountry: () => http.get(`${BASE_URL_COUNTRY}/verify_email/settings`),
  getSettingsVerifyEmail: () => http.get(`${BASE_URL_EMAIL}/verify_email/settings`),
  getSettingsSMSReviewrequest: () => http.get(`${BASE_URL_EMAIL}/review_request_sms/settings`),
  getPreviewReviewrequest: () => http.get(`${BASE_URL_EMAIL}/review_request/preview`),
  getPreviewCoupon: () => http.get(`${BASE_URL_EMAIL}/coupon/preview`),
  getPreviewVerifyEmail: () => http.get(`${BASE_URL_EMAIL}/verify_email/preview`),
  getPreviewPage: () => http.get(`${BASE_URL_PAGE}/thank_you_for_review/preview`),
  getPreviewPhotoRequest: () => http.get(`${BASE_URL_EMAIL}/photo_request/preview`),
  getPreviewReviewrequestSMS: () => http.get(`${BASE_URL_EMAIL}/review_request_sms/preview`),
  getPreviewOrderPrinter: () => http.get(`${BASE_URL_EMAIL}/order_printer/preview`),

  // POST
  postSettingsEmailReviewrequest: (from_email, from_name, subject, preheader) => {
    const params = {
      from_email,
      from_name,
      subject,
      preheader,
    };
    return http.post(`${BASE_URL_EMAIL}/review_request/settings`, params);
  },
  postSettingsEmailReviewrequestCountry: (
    from_email,
    from_name,
    subject,
    preheader,
    templateHtml,
    templateJson,
    country,
    copyFromCountry
  ) => {
    templateJson = JSON.stringify(templateJson);
    const params = {
      from_email,
      from_name,
      subject,
      preheader,
      templateHtml,
      templateJson,
      country,
      copyFromCountry,
    };
    return http.post(`${BASE_URL_COUNTRY}/review_request/settings`, params);
  },
  postSettingsEmailCoupon: (from_email, from_name, subject, preheader) => {
    const params = {
      from_email,
      from_name,
      subject,
      preheader,
    };
    return http.post(`${BASE_URL_EMAIL}/coupon/settings`, params);
  },
  postSettingsEmailCouponCountry: (
    from_email,
    from_name,
    subject,
    preheader,
    templateHtml,
    templateJson,
    country,
    copyFromCountry
  ) => {
    templateJson = JSON.stringify(templateJson);
    const params = {
      from_email,
      from_name,
      subject,
      preheader,
      templateHtml,
      templateJson,
      country,
      copyFromCountry,
    };
    return http.post(`${BASE_URL_COUNTRY}/coupon/settings`, params);
  },
  postCreateSMSTemplateCountry: (
    from_email,
    from_name,
    subject,
    preheader,
    templateHtml,
    templateJson,
    country,
    copyFromCountry
  ) => {
    templateJson = JSON.stringify(templateJson);
    const params = {
      from_email,
      from_name,
      subject,
      preheader,
      templateHtml,
      templateJson,
      country,
      copyFromCountry,
    };
    return http.post(`${BASE_URL_COUNTRY}/review_request_sms/settings`, params);
  },
  postSettingsEmailVerifyEmail: (from_email, from_name, subject, preheader) => {
    const params = {
      from_email,
      from_name,
      subject,
      preheader,
    };
    return http.post(`${BASE_URL_EMAIL}/verify_email/settings`, params);
  },
  postSettingsEmailVerifyEmailCountry: (
    from_email,
    from_name,
    subject,
    preheader,
    templateHtml,
    templateJson,
    country,
    copyFromCountry
  ) => {
    templateJson = JSON.stringify(templateJson);
    const params = {
      from_email,
      from_name,
      subject,
      preheader,
      templateHtml,
      templateJson,
      country,
      copyFromCountry,
    };
    return http.post(`${BASE_URL_COUNTRY}/verify_email/settings`, params);
  },
  postSettingsPhotoRequestEmail: (from_email, from_name, subject, preheader) => {
    const params = {
      from_email,
      from_name,
      subject,
      preheader,
    };
    return http.post(`${BASE_URL_EMAIL}/photo_request/settings`, params);
  },
  postSettingsPhotoRequestEmailCountry: (
    from_email,
    from_name,
    subject,
    preheader,
    templateHtml,
    templateJson,
    country,
    copyFromCountry
  ) => {
    templateJson = JSON.stringify(templateJson);
    const params = {
      from_email,
      from_name,
      subject,
      preheader,
      templateHtml,
      templateJson,
      country,
      copyFromCountry,
    };
    return http.post(`${BASE_URL_COUNTRY}/photo_request/settings`, params);
  },
  postSettingsSMSReviewrequest: from_name => {
    const params = {
      from_name,
    };
    return http.post(`${BASE_URL_EMAIL}/review_request_sms/settings`, params);
  },

  postDesignReviewRequest: (template_json, template_html, advanced_template = true) => {
    template_json = JSON.stringify(template_json);
    const params = {
      template_json,
      template_html,
      advanced_template,
    };
    return http.post(`${BASE_URL_EMAIL}/review_request/save-template`, params);
  },
  postDesignReviewRequestCountry: (
    template_json,
    template_html,
    advanced_template = true,
    country
  ) => {
    template_json = JSON.stringify(template_json);
    const params = {
      template_json,
      template_html,
      advanced_template,
      country,
    };
    return http.post(`${BASE_URL_COUNTRY}/review_request/save-country-template`, params);
  },
  postSaveCountryThxPage: (template_html, template_json, country, copyFromCountry) => {
    template_json = JSON.stringify(template_json);
    const params = {
      template_html,
      template_json,
      country,
      copyFromCountry,
    };
    return http.post(`${BASE_URL_PAGE}/thank_you_for_review/save-country-page`, params);
  },
  postDesignCoupon: (template_dict, template_html, advanced_template = true) => {
    const template_json = JSON.stringify(template_dict);
    const params = {
      template_json,
      template_html,
      advanced_template,
    };
    return http.post(`${BASE_URL_EMAIL}/coupon/save-template`, params);
  },
  postDesignCouponCountry: (template_json, template_html, advanced_template = true, country) => {
    template_json = JSON.stringify(template_json);
    const params = {
      template_json,
      template_html,
      advanced_template,
      country,
    };
    return http.post(`${BASE_URL_COUNTRY}/coupon/save-country-template`, params);
  },
  postDesignVerifyEmail: (template_json, template_html, advanced_template) => {
    template_json = JSON.stringify(template_json);
    const params = {
      template_json,
      template_html,
      advanced_template,
    };
    return http.post(`${BASE_URL_EMAIL}/verify_email/save-template`, params);
  },
  postDesignVerifyEmailCountry: (
    template_json,
    template_html,
    advanced_template = true,
    country
  ) => {
    template_json = JSON.stringify(template_json);
    const params = {
      template_json,
      template_html,
      advanced_template,
      country,
    };
    return http.post(`${BASE_URL_COUNTRY}/verify_email/save-country-template`, params);
  },
  postDesignThxPage: (template_json, template_html) => {
    template_json = JSON.stringify(template_json);
    const params = {
      template_json,
      template_html,
    };
    return http.post(`${BASE_URL_PAGE}/thank_you_for_review/save-template`, params);
  },
  postDesignPhotoRequest: (template_json, template_html, advanced_template) => {
    template_json = JSON.stringify(template_json);
    const params = {
      template_json,
      template_html,
      advanced_template,
    };
    return http.post(`${BASE_URL_EMAIL}/photo_request/save-template`, params);
  },
  postDesignPhotoRequestCountry: (
    template_json,
    template_html,
    advanced_template = true,
    country
  ) => {
    template_json = JSON.stringify(template_json);
    const params = {
      template_json,
      template_html,
      advanced_template,
      country,
    };
    return http.post(`${BASE_URL_COUNTRY}/photo_request/save-country-template`, params);
  },
  postDesignReviewRequestSms: (template_json, template_html) => {
    template_json = JSON.stringify(template_json);
    const params = {
      template_json,
      template_html,
    };
    return http.post(`${BASE_URL_EMAIL}/review_request_sms/save-template`, params);
  },
  postReviewRequestSmsCountry: (country, template_json, template_html) => {
    template_json = JSON.stringify(template_json);
    const params = {
      country,
      template_json,
      template_html,
    };
    return http.post(`${BASE_URL_COUNTRY}/review_request_sms/save-country-template`, params);
  },
  postDesignOrderPrinter: (template_json, template_html) => {
    template_json = JSON.stringify(template_json);
    const params = {
      template_json,
      template_html,
    };
    return http.post(`${BASE_URL_EMAIL}/order_printer/save-template`, params);
  },

  postDestinationReviewRequest: (destination_email, advanced_template, country) => {
    const params = {
      destination_email,
      advanced_template,
      country,
    };
    return http.post(`${BASE_URL_EMAIL}/review_request/send-test-email`, params);
  },
  postDestinationCoupon: (destination_email, advanced_template, country) => {
    const params = {
      destination_email,
      advanced_template,
      country,
    };
    return http.post(`${BASE_URL_EMAIL}/coupon/send-test-email`, params);
  },
  postDestinationVerifyEmail: (destination_email, advanced_template, country) => {
    const params = {
      destination_email,
      advanced_template,
      country,
    };
    return http.post(`${BASE_URL_EMAIL}/verify_email/send-test-email`, params);
  },
  postDestinationPhotoRequest: (destination_email, advanced_template, country) => {
    const params = {
      destination_email,
      advanced_template,
      country,
    };
    return http.post(`${BASE_URL_EMAIL}/photo_request/send-test-email`, params);
  },

  postResetReviewRequestDesign: (advanced_template, country) => {
    const params = {
      advanced_template,
      country,
    };
    return http.post(`${BASE_URL_EMAIL}/review_request/reset`, params);
  },
  postResetCouponDesign: (advanced_template, country) => {
    const params = {
      advanced_template,
      country,
    };
    return http.post(`${BASE_URL_EMAIL}/coupon/reset`, params);
  },
  postResetVerifyEmailDesign: (advanced_template, country) => {
    const params = {
      advanced_template,
      country,
    };
    return http.post(`${BASE_URL_EMAIL}/verify_email/reset`, params);
  },
  postResetThxPage: template_name => {
    const params = {
      template_name,
    };
    return http.post(`${BASE_URL_PAGE}/thank_you_for_review/reset`, params);
  },
  postResetThxPageCountry: country => {
    const params = {
      country,
    };
    return http.post(`${BASE_URL_PAGE_COUNTRY}/thank_you_for_review/reset`, params);
  },
  postResetPhotoRequestDesign: (advanced_template, country) => {
    const params = {
      advanced_template,
      country,
    };
    return http.post(`${BASE_URL_EMAIL}/photo_request/reset`, params);
  },
  postResetReviewRequestSMSDesign: (advanced_template, country) => {
    const params = {
      advanced_template,
      country,
    };
    return http.post(`${BASE_URL_EMAIL}/review_request_sms/reset`, params);
  },
  postResetOrderPrinterDesign: () => {
    const params = {
      country: null,
    };
    return http.post(`${BASE_URL_EMAIL}/order_printer/reset`, params);
  },
  postTestReviewRequestFlow: (email, products) => {
    const params = {
      email,
      products,
    };
    return http.post('/test-review-request-flow', params).then(r => r.data);
  },
  deleteReviewRequestCountryTemplate: country => {
    const params = {
      country,
    };
    return http.post(`${BASE_URL_COUNTRY}/review_request/delete`, params);
  },
  deleteCouponCountryTemplate: country => {
    const params = {
      country,
    };
    return http.post(`${BASE_URL_COUNTRY}/coupon/delete`, params);
  },
  deleteVerifyEmailCountryTemplate: country => {
    const params = {
      country,
    };
    return http.post(`${BASE_URL_COUNTRY}/verify_email/delete`, params);
  },
  deletePhotoCountryTemplate: country => {
    const params = {
      country,
    };
    return http.post(`${BASE_URL_COUNTRY}/photo_request/delete`, params);
  },
  deleteSmsCountryTemplate: country => {
    const params = {
      country,
    };
    return http.post(`${BASE_URL_COUNTRY}/review_request_sms/delete`, params);
  },
  deletePageCountryTemplate: country => {
    const params = {
      country,
    };
    return http.post(`${BASE_URL_PAGE}/thank_you_for_review/delete`, params);
  },
  getTestOrderData: () => http.get('/test-review-request-data').then(r => r.data),
};
